/**
 * App.js — Root component that handles Firebase authentication gating.
 * Renders either the Login screen (unauthenticated) or the main app routes
 * (authenticated) by swapping between two separate routers.
 */
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
// ------------------------------------------------
import { initFirebase } from "System/firebase";
// ------------------------------------------------
import { signin, signout } from "Redux/user/actions";
// ------------------------------------------------
import Project from "Project";
import Projects from "Projects";
import Login from "Login";

// ------------------------------------------------
/** Router for unauthenticated users — all paths show Login. */
const routerOuter = createBrowserRouter([
  {
    path: "*",
    element: <Login />,
  },
]);

// ------------------------------------------------
/** Router for authenticated users — project list and individual project workspace. */
const routerInner = createBrowserRouter([
  {
    path: "/",
    element: <Projects />,
  },
  {
    path: "/project/:pid/:setup",
    element: <Project />,
  },

]);


// ------------------------------------------------
// ------------------------------------------------
const App = () => {

  const dispatch = useDispatch();
  const { uid } = useSelector((state) => state.user);

  // Initialize Firebase once on mount, then subscribe to auth state changes.
  // The listener persists for the app lifetime, syncing Redux with Firebase auth.
  useEffect(() => {
    initFirebase();
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (user) {
        dispatch(signin(user));
      } else {
        dispatch(signout());
      }
    });
  }, [dispatch]);

  // uid is undefined while Firebase auth state is still loading — show nothing yet.
  if(uid === undefined) {
    return <div>...</div>
  }

  // Swap the entire router based on auth state (not just routes) to avoid
  // unauthenticated users seeing protected route shells.
  const router = uid ? routerInner : routerOuter;
  return <RouterProvider router={router} />;
};

export default App;
// ------------------------------------------------